import Vue from 'vue'

export function getAuth() {
    return Vue.http.get('api/auth')
}

export function getViz(path) {
    return Vue.http.get('api/viz', {
        params: {
            path: path
        }
    })
}

export function getParameter(path) {
    return Vue.http.get('api/para', {
        params: {
            path: path
        }
    })
}

export function postParameter(path, parameter, parameterData) {
    return Vue.http.post('api/para', {
        Path: path,
        ChangedParameter: parameter,
        ParameterList: parameterData
    })
}

export function getReport(path) {
    return Vue.http.get('api/ssrs', {
        params: {
            path: path
        }
    })
}

export function getReportSnapshot(path, pcList, genReport) {
    return Vue.http.post('api/ssrs', {
        Path: path,
        ParameterControlList: pcList,
        GenReport: genReport
    })
}

export function getFile(fileName) {
    return Vue.http.get('api/file', {
        params: {
            fileName: fileName
        },
        responseType:'blob'
    })
}

export function deleteWorkbook(workbookId) {
    return Vue.http.delete('api/customize', {
        params: {
            workbookId: workbookId
        }
    })
}




// WEBPACK FOOTER //
// ./src/api.js